export const getCommonProps = (props) => {
    return { 'data-testid': props['data-testid'] };
};
export const getUncommonProps = (props) => {
    const commonPropKeys = Object.keys(getCommonProps(props));
    return Object.keys(props).filter((propKey) => !commonPropKeys.includes(propKey)).reduce((accumulator, propKey) => (Object.assign(Object.assign({}, accumulator), { [propKey]: props[propKey] })), {});
};
